<template>
  <form
    class="position-relative md"
    ref="form"
    @submit.prevent="onFormSubmit"
    :action="formAction"
  >
    <div class="">
      <div :class="'input-group ' + searchBlockStyle">
        <div class="input-group-prepend">
          <div :class="buttonStyle" tabindex="-1" class="btn">
            <Icon
              icon="simple-line-icons:magnifier"
              :color="iconcolor"
              :width="iconsize"
            />
          </div>
        </div>
        <input
          type="search"
          autocorrect="off"
          autocapitalize="off"
          autocomplete="off"
          spellcheck="false"
          required
          maxlength="512"
          aria-label="Search"
          name="searchTerm"
          class="form-control border-0 m-auto"
          :class="inputClasses"
          :value="value"
          @input="inputValue"
          :placeholder="placeholderValue"
          ref="input"
          @keydown.enter.prevent
        />
        <div class="input-group-prepend">
          <button
            class="nav-top-customer-link nav-link btn btn-gray"
            type="button"
            data-toggle="collapse"
            :data-target="isInspiration?'':'#menu-search-mobile-collapse'"
            aria-expanded="false"
            aria-controls="menu-search-mobile-collapse"
            @click.prevent = "handleCancel"
          >
            cancel
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { Icon } from "@iconify/vue2";
import { mapActions } from "vuex";

export default {
  props: [
    "placeholderValue",
    "searchBlockStyle",
    "iconsize",
    "iconcolor",
    "onInput",
    "formAction",
    "inputClasses",
    "buttonStyle",
    "value",
    "isInspiration"
  ],
  components: {
    Icon
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      setScope: "searchMenu/setScope"
    }),
    inputValue(event) {
      this.onInput(event.target.value);
      if (this.inputClasses === "site-search-input" && this.$refs.input.value) {
        this.setScope("all");
      }
    },
    handleCancel(){
      if (this.$refs.input.value) {
        this.onInput("");
      }
    },

    onFormSubmit(e) {
      // e.preventDefault(); // Prevent form submission
      if (!this.formAction) {
        return;
      }
      // Only submit the form if there is a search input value
      const input = this.$refs.input;
      const form = this.$refs.form;
      if (input.value) {
        this.onInput(input.value);
        window.location.href = this.formAction;
      }
    }
  }
};
</script>
